<template>
  <div>
    <header-component position-relation></header-component>
    <div class="message-board-container">
      <div id="messageBoardBody" v-if="messageBoardList.length > 0" class="message-board-body">
        <div class="message-board-picture">
          <!--
          <div v-for="n in 5" :key="`MultiGroup_${n}`" class="message-board-single-group">
            <div v-for="k in 3" :key="`OneGroup_${k}`" class="message-board-single-row">
              <div v-for="s in 3" :key="`Single_${s}`" class="single-message">
                <message-board-card :message-board-data="getMessageBoard(n, k, s)"></message-board-card>
              </div>
            </div>
          </div>
          -->
          <div class="message-board-single-group">
            <div class="message-board-single-row">
              <div class="single-message">
                <message-board-card :message-board-data="getMessageBoardByIndex(0)"></message-board-card>
              </div>
              <div class="single-message">
                <message-board-card :message-board-data="getMessageBoardByIndex(1)"></message-board-card>
              </div>
              <div class="single-message">
                <message-board-card :message-board-data="getMessageBoardByIndex(2)"></message-board-card>
              </div>
            </div>
            <div class="message-board-single-row">
              <div class="single-message">
                <message-board-card :message-board-data="getMessageBoardByIndex(3)"></message-board-card>
              </div>
              <div class="single-message">
                <message-board-card :message-board-data="getMessageBoardByIndex(4)"></message-board-card>
              </div>
              <div class="single-message">
                <message-board-card :message-board-data="getMessageBoardByIndex(5)"></message-board-card>
              </div>
            </div>
            <div class="message-board-single-row">
              <div class="single-message">
                <message-board-card :message-board-data="getMessageBoardByIndex(6)"></message-board-card>
              </div>
              <div class="single-message">
                <message-board-card :message-board-data="getMessageBoardByIndex(7)"></message-board-card>
              </div>
              <div class="single-message">
                <message-board-card :message-board-data="getMessageBoardByIndex(8)"></message-board-card>
              </div>
            </div>
          </div>
          <div class="message-board-single-group">
            <div class="message-board-single-row">
              <div class="single-message">
                <message-board-card :message-board-data="getMessageBoardByIndex(9)"></message-board-card>
              </div>
              <div class="single-message">
                <message-board-card :message-board-data="getMessageBoardByIndex(10)"></message-board-card>
              </div>
              <div class="single-message">
                <message-board-card :message-board-data="getMessageBoardByIndex(11)"></message-board-card>
              </div>
            </div>
            <div class="message-board-single-row">
              <div class="single-message">
                <message-board-card :message-board-data="getMessageBoardByIndex(12)"></message-board-card>
              </div>
              <div class="single-message">
                <message-board-card :message-board-data="getMessageBoardByIndex(13)"></message-board-card>
              </div>
              <div class="single-message">
                <message-board-card :message-board-data="getMessageBoardByIndex(14)"></message-board-card>
              </div>
            </div>
            <div class="message-board-single-row">
              <div class="single-message">
                <message-board-card :message-board-data="getMessageBoardByIndex(15)"></message-board-card>
              </div>
              <div class="single-message">
                <message-board-card :message-board-data="getMessageBoardByIndex(16)"></message-board-card>
              </div>
              <div class="single-message">
                <message-board-card :message-board-data="getMessageBoardByIndex(17)"></message-board-card>
              </div>
            </div>
          </div>
          <div class="message-board-single-group">
            <div class="message-board-single-row">
              <div class="single-message">
                <message-board-card :message-board-data="getMessageBoardByIndex(18)"></message-board-card>
              </div>
              <div class="single-message">
                <message-board-card :message-board-data="getMessageBoardByIndex(19)"></message-board-card>
              </div>
              <div class="single-message">
                <message-board-card :message-board-data="getMessageBoardByIndex(20)"></message-board-card>
              </div>
            </div>
            <div class="message-board-single-row">
              <div class="single-message">
                <message-board-card :message-board-data="getMessageBoardByIndex(21)"></message-board-card>
              </div>
              <div class="single-message">
                <message-board-card :message-board-data="getMessageBoardByIndex(22)"></message-board-card>
              </div>
              <div class="single-message">
                <message-board-card :message-board-data="getMessageBoardByIndex(23)"></message-board-card>
              </div>
            </div>
            <div class="message-board-single-row">
              <div class="single-message">
                <message-board-card :message-board-data="getMessageBoardByIndex(24)"></message-board-card>
              </div>
              <div class="single-message">
                <message-board-card :message-board-data="getMessageBoardByIndex(25)"></message-board-card>
              </div>
              <div class="single-message">
                <message-board-card :message-board-data="getMessageBoardByIndex(26)"></message-board-card>
              </div>
            </div>
          </div>
          <div class="message-board-single-group">
            <div class="message-board-single-row">
              <div class="single-message">
                <message-board-card :message-board-data="getMessageBoardByIndex(27)"></message-board-card>
              </div>
              <div class="single-message">
                <message-board-card :message-board-data="getMessageBoardByIndex(28)"></message-board-card>
              </div>
              <div class="single-message">
                <message-board-card :message-board-data="getMessageBoardByIndex(29)"></message-board-card>
              </div>
            </div>
            <div class="message-board-single-row">
              <div class="single-message">
                <message-board-card :message-board-data="getMessageBoardByIndex(30)"></message-board-card>
              </div>
              <div class="single-message">
                <message-board-card :message-board-data="getMessageBoardByIndex(31)"></message-board-card>
              </div>
              <div class="single-message">
                <message-board-card :message-board-data="getMessageBoardByIndex(32)"></message-board-card>
              </div>
            </div>
            <div class="message-board-single-row">
              <div class="single-message">
                <message-board-card :message-board-data="getMessageBoardByIndex(33)"></message-board-card>
              </div>
              <div class="single-message">
                <message-board-card :message-board-data="getMessageBoardByIndex(34)"></message-board-card>
              </div>
              <div class="single-message">
                <message-board-card :message-board-data="getMessageBoardByIndex(35)"></message-board-card>
              </div>
            </div>
          </div>
          <div class="message-board-single-group">
            <div class="message-board-single-row">
              <div class="single-message">
                <message-board-card :message-board-data="getMessageBoardByIndex(36)"></message-board-card>
              </div>
              <div class="single-message">
                <message-board-card :message-board-data="getMessageBoardByIndex(37)"></message-board-card>
              </div>
              <div class="single-message">
                <message-board-card :message-board-data="getMessageBoardByIndex(38)"></message-board-card>
              </div>
            </div>
            <div class="message-board-single-row">
              <div class="single-message">
                <message-board-card :message-board-data="getMessageBoardByIndex(39)"></message-board-card>
              </div>
              <div class="single-message">
                <message-board-card :message-board-data="getMessageBoardByIndex(40)"></message-board-card>
              </div>
              <div class="single-message">
                <message-board-card :message-board-data="getMessageBoardByIndex(41)"></message-board-card>
              </div>
            </div>
            <div class="message-board-single-row">
              <div class="single-message">
                <message-board-card :message-board-data="getMessageBoardByIndex(42)"></message-board-card>
              </div>
              <div class="single-message">
                <message-board-card :message-board-data="getMessageBoardByIndex(43)"></message-board-card>
              </div>
              <div class="single-message">
                <message-board-card :message-board-data="getMessageBoardByIndex(44)"></message-board-card>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="getDeviceType !== DeviceTypeEnum.MOBILE" class="message-input body-max-container">
        <div class="message-input-title"><span>預覽</span></div>
        <message-board-card class="message-preview" :message-board-data="messageBoardData"></message-board-card>
        <div class="message-input-box">
          <img class="dog-img" src="../assets/img/paper/swiper-card.png" alt>
          <div class="message-input-textarea">
            <span class="message-input-textarea-title">關於毛小孩，我想說的是...</span>
            <el-input
              type="textarea"
              v-model="messageBoardData.message"
              :rows="5"
              :maxlength="100"
              resize="none"
              placeholder="輸入文字..."
              show-word-limit
            ></el-input>
            <div class="message-paper-selector">
              <div class="enter-btn message-paper-color-picker message-paper-green" @click="handleChangePaper(0)"></div>
              <div class="enter-btn message-paper-color-picker message-paper-pink" @click="handleChangePaper(1)"></div>
              <div class="enter-btn message-paper-color-picker message-paper-yellow" @click="handleChangePaper(2)"></div>
              <div class="enter-btn message-paper-color-picker message-paper-blue" @click="handleChangePaper(3)"></div>
            </div>
          </div>
          <div class="enter-btn submit-btn" @click="goSubmit">
            <img src="../assets/img/icon-arrow-right.svg" alt />
          </div>
        </div>
      </div>
      <div v-else class="mobile-message-input body-max-container">
        <div class="message-input-box">
          <img class="dog-img" src="../assets/img/paper/swiper-card.png" alt>
          <div class="message-input-textarea">
            <el-input
              type="textarea"
              v-model="messageBoardData.message"
              :rows="5"
              :maxlength="100"
              :style="getPaperStyle"
              resize="none"
              placeholder="輸入文字..."
              show-word-limit
            ></el-input>
            <div class="message-paper-selector">
              <div class="enter-btn message-paper-color-picker message-paper-green" @click="handleChangePaper(0)"></div>
              <div class="enter-btn message-paper-color-picker message-paper-pink" @click="handleChangePaper(1)"></div>
              <div class="enter-btn message-paper-color-picker message-paper-yellow" @click="handleChangePaper(2)"></div>
              <div class="enter-btn message-paper-color-picker message-paper-blue" @click="handleChangePaper(3)"></div>
            </div>
          </div>
          <div class="enter-btn" @click="goSubmit">
            <img src="../assets/img/icon-arrow-right.svg" alt />
          </div>
        </div>
      </div>
    </div>
    <footer-component></footer-component>
  </div>
</template>

<script>
import HeaderComponent from "../components/HeaderComponent";
import FooterComponent from "../components/FooterComponent";
import { MessageBoardModel } from "@/models/message-board-model";
import MessageBoardCard from "@/components/MessageBoardCard";
import { DeviceTypeEnum } from "@/utils/enum";
import { fetchMessageBoard, addMessageBoard } from "@/apis/messageBoard";
import { ResponseModel } from "@/models/response-model";
import IndexMixin from "@/mixins/index-mixin";

export default {
  name: "MessageBoard",
  mixins: [IndexMixin],
  components: { FooterComponent, HeaderComponent, MessageBoardCard },
  computed: {
    getDeviceType() {
      return this.$store.getters.device
    },
    getPaperStyle() {
      const paper = this.messageBoardData.color
      let cssStyle = ''
      switch (paper) {
        case 0:
          cssStyle = `background-image: url(${this.$store.getters.messageBoardGreenImage}) !important;`
          break
        case 1:
          cssStyle = `background-image: url(${this.$store.getters.messageBoardPinkImage}) !important;`
          break
        case 2:
          cssStyle = `background-image: url(${this.$store.getters.messageBoardYellowImage}) !important;`
          break
        case 3:
          cssStyle = `background-image: url(${this.$store.getters.messageBoardBlueImage}) !important;`
          break
        default:
          cssStyle = `background-image: url(${this.$store.getters.messageBoardGreenImage}) !important;`
      }
      return cssStyle
    },
    getPaperClass() {
      switch (this.messageBoardData.Color) {
        case 0:
          return "paper-green"
        case 1:
          return "paper-pink"
        case 2:
          return "paper-yellow"
        case 3:
          return "paper-blue"
        default:
          return "paper-green"
      }
    },
  },
  data() {
    return {
      DeviceTypeEnum,
      messageBoardList: [],
      messageBoardData: new MessageBoardModel()
    }
  },
  created() {
    window.scroll(0, 0)
  },
  mounted() {
    this.openLoading()
    this.initMessageBoard().then(() => {
      this.closeLoading()
    })
    // this.$nextTick(() => {
    //   window.addEventListener('resize', this.setupSwiper)
    //   const element = document.getElementById("messageBoardBody")
    //   element.scroll(element.scrollWidth / 4, 0)
    // })
  },
  methods: {
    getMessageBoard(n, k, s) {
      const index = ((n - 1) * 9) + ((k - 1) * 3) + (s - 1)
      // console.log(`n:${n}, k:${k}, s:${s}, index:${index}`)
      return this.messageBoardList[index]
    },
    getMessageBoardByIndex(index) {
      return this.messageBoardList[index]
    },
    async initMessageBoard() {
      try {
        const response = await fetchMessageBoard()
        const responseData = new ResponseModel(response)
        const { messageBoardList } = responseData.result
        const loop = Math.ceil((9 * 5) / messageBoardList.length)
        const list = []
        for (let k = 0; k < loop; k++) {
          for (const i in messageBoardList) {
            list.push(new MessageBoardModel(messageBoardList[i]))
          }
        }
        // this.messageBoardList = list.sort(function () {
        //   return Math.random() - 0.5;
        // });
        this.messageBoardList = list;
        // console.log(` messages.length : ${ messageBoardList.length }, loop : ${loop}, final length : ${this.messageBoardList.length}`)
        return Promise.resolve(true)
      } catch (e) {
        console.log(e)
        return Promise.resolve(true)
      }
    },
    handleChangePaper(color) {
      console.log(`handleChangePaper : ${color}`)
      this.messageBoardData.color = color
    },
    goSubmit() {
      if (this.$store.getters.token && this.messageBoardData.message && this.messageBoardData.message.trim().length > 0) {
        addMessageBoard(this.messageBoardData.save).then(res => {
          const responseData = new ResponseModel(res)
          if (responseData.isSuccess) {
            this.$12nightsAlert({
              title: "提示",
              message: "送出成功，等待管理員審核！"
            }).then(() => {
            })
          } else {
            this.$12nightsAlert({
              title: "錯誤提示",
              message: "送出失敗"
            }).then(() => {
            })
          }
        }).catch(e => {
          this.$12nightsAlert({
            title: "錯誤提示",
            message: e.toString()
          }).then(() => {
          })
        })
      } else if (this.$store.getters.token) {
        this.$12nightsAlert({
          title: "提示",
          message: "您還沒寫下文字！"
        }).then(() => {
        })
      } else {
        this.$12nightsConfirm({
          title: "錯誤提示",
          message: "請先登入會員！"
        }).then(() => {
          this.$router.push({
            name: "Login"
          })
        })
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
